import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import {
  Sgke382aRequest,
  Sgke382aResponse,
  Sgke382aService
} from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke382aService {

  /**
   * コンストラクタ
   * @param {Sgke382aService} service
   * @param {ApiCommonService} apiCommonService 
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgke382aService
   */
  constructor(
    public service: Sgke382aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * SGKE382A_サービサー委託対象登録API呼出し
   * @param {Sgke382aRequest} request 
   * @returns {*}  {Observable<Sgke382aResponse>}
   * @memberof UsedSgke382aService
   */
  public doSgke382a(request: Sgke382aRequest): Observable<Sgke382aResponse> {

    return this.service.sgke382aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),

        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE382A');
          return throwError(err.message);
        })
      );
  }

}
